import Swiper from "swiper/bundle";

export const QuizMain = () => {
  const $quizMain = document.querySelector("section.quiz-main");

  if ($quizMain) {
    const $siteHeader = document.querySelector(
      ".tribe-site-header.js-site-header"
    );
    const setQuizHeight = () => {
      const siteHeaderHeight = $siteHeader.getBoundingClientRect().height;
      $quizMain.style.setProperty("--quiz-height", `${siteHeaderHeight}px`);
    };

    window.addEventListener("resize", () => {
      setQuizHeight();
    });
    setQuizHeight();

    const $quizMainContents = $quizMain.querySelector(".quiz-main__contents");
    const $contentsInfo = $quizMainContents.querySelector(".contents__info");

    const $quizButtons = $contentsInfo.querySelectorAll(
      ".info__actions button.quiz-main__button.quiz-main__button--is-quiz"
    );

    const $quizOkendo = $quizMain.querySelector(".quiz__okendo");

    $quizButtons.forEach(($quizButton) => {
      $quizButton.addEventListener("click", (event) => {
        event.preventDefault();
        $quizOkendo.classList.add("quiz__okendo--active");
        $quizMainContents.classList.add("quiz-main__contents--inactive");
        window.scrollTo(0, 0);
      });
    });
  }
};

window.okeConnectApi = window.okeConnectApi || {};

let firstProductRecomendationAdded = false;
window.okeConnectApi.recommendedProductsMounted = (section, products) => {
  const productData = JSON.parse(JSON.stringify(products));

  if (!firstProductRecomendationAdded) {
    firstProductRecomendationAdded = true;

    section.innerHTML = "";
    renderMainRecommendation(section, productData[0]);
  } else {
    section.innerHTML = "";
    renderOtherRecommendations(section, productData);
  }
};

function handleize(str) {
  return str
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // strip non-word chars (keeps accented? no — matches Shopify's ASCII behaviour roughly)
    .replace(/[\s_]+/g, "-") // spaces/underscores → hyphen
    .replace(/-+/g, "-") // collapse multiple hyphens
    .replace(/^-+|-+$/g, ""); // trim leading/trailing hyphens
}

function escapeHtml(str) {
  return str
    .toString()
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function formatMoney(amount, currencyCode = "GBP") {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currencyCode,
  }).format(amount);
}

// Mirrors the site-wide add-to-cart behaviour (see product-template/modules/product.js).
const openCartAside = () => {
  const cart = window.Carbon?.Cart;

  if (!cart?.useCartAside) {
    window.location = "/cart";
    return;
  }

  const $cartAsideBackground = document.querySelector(
    ".cart-aside__background"
  );
  const $cartAside = $cartAsideBackground?.querySelector("aside.cart-aside");
  if (!$cartAside) return;

  document.querySelector("body").classList.add("overflow-y-hidden");
  $cartAsideBackground.classList.remove("pointer-events-none");
  $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
  $cartAside.classList.remove(
    "translate-x-full",
    "ponter-events-none",
    "hidden"
  );
};

// Wires up the variant/option selects, purchase-type toggle, quantity stepper
// and add-to-cart button for a rendered recommendation card. Adapted from the
// original quiz-results section, with prices treated as pounds (Okendo) rather
// than pence, and guards for the simplified "other product" cards.
const setUpFunctionality = ($infoElement) => {
  if (!$infoElement) return;

  const $variantsSelect = $infoElement.querySelector(
    ".controls__variants .variants__select"
  );
  if (!$variantsSelect) return;

  const $infoPrice = $infoElement.querySelector(".info__price");
  const $optionContainers = $infoElement.querySelectorAll(".option__container");
  const $optionsSelects = $infoElement.querySelectorAll(
    ".controls__options .option__select"
  );

  const $controlsPurchaseTypes = $infoElement.querySelector(
    ".controls__purchase-types"
  );
  const $purchaseTypeOneTime = $controlsPurchaseTypes?.querySelector(
    ".purchase-type--one-time"
  );
  const $purchaseTypeSubscribe = $controlsPurchaseTypes?.querySelector(
    ".purchase-type--subscribe"
  );

  const $sellingPlansSelect = $infoElement.querySelector(
    ".controls__selling-plans .container__select"
  );

  const $controlsButtons = $infoElement.querySelector(".controls__buttons");
  const $buttonCart = $controlsButtons?.querySelector(
    ".controls__button--cart"
  );
  const $buttonCartPrice = $buttonCart?.querySelector(".button__price");
  const $buttonViewDetails = $controlsButtons?.querySelector(
    ".controls__button--details"
  );

  const $quantityValue = $controlsButtons?.querySelector(".quantity__value");
  const $quantityUp = $controlsButtons?.querySelector(
    ".quantity__buttons .quantity__up"
  );
  const $quantityDown = $controlsButtons?.querySelector(
    ".quantity__buttons .quantity__down"
  );

  const isSubscribeActive = () =>
    !!(
      $purchaseTypeSubscribe?.classList.contains("purchase-type--active") &&
      $sellingPlansSelect
    );

  const getQuantity = () =>
    $quantityValue ? parseInt($quantityValue.dataset.value) : 1;

  const updatePrices = () => {
    const $selected = $variantsSelect.options[$variantsSelect.selectedIndex];
    let unitPrice = parseFloat($selected.dataset.variantPrice);

    if (isSubscribeActive()) {
      const plans = JSON.parse(
        $selected.dataset.sellingPlanAllocations || "[]"
      );
      if (plans[0]?.price != null) unitPrice = parseFloat(plans[0].price);
    }

    const formatted = formatMoney(unitPrice * getQuantity());
    if ($infoPrice) $infoPrice.innerText = formatted;
    if ($buttonCartPrice) $buttonCartPrice.innerText = formatted;
  };

  const setSubscribeState = (subscribe) => {
    const modifier = $infoElement.classList.contains("recomended__info")
      ? "recomended__info--subscribe"
      : "product-info--subscribe";
    $infoElement.classList.toggle(modifier, subscribe);
  };

  const syncOptionButtons = () => {
    $optionContainers.forEach(($container) => {
      const $select = $container.querySelector(".option__select");
      if (!$select) return;
      $container
        .querySelectorAll(".option__buttons .option__button")
        .forEach(($button) => {
          $button.classList.toggle(
            "option__button--selected",
            $button.dataset.optionValue === $select.value
          );
        });
    });
  };

  const getOptionsString = () =>
    [...$optionsSelects].map(($select) => $select.value).join("-");

  const findVariant = (optionString) => {
    for (const option of $variantsSelect.options) {
      if (option.dataset.variantHandle === optionString) return option.value;
    }
    return null;
  };

  $purchaseTypeOneTime?.addEventListener("click", (event) => {
    event.preventDefault();
    $purchaseTypeOneTime.classList.add("purchase-type--active");
    $purchaseTypeSubscribe?.classList.remove("purchase-type--active");
    setSubscribeState(false);
    updatePrices();
  });

  $purchaseTypeSubscribe?.addEventListener("click", (event) => {
    event.preventDefault();
    $purchaseTypeSubscribe.classList.add("purchase-type--active");
    $purchaseTypeOneTime?.classList.remove("purchase-type--active");
    setSubscribeState(true);
    updatePrices();
  });

  $sellingPlansSelect?.addEventListener("change", updatePrices);

  if ($quantityUp && $quantityValue) {
    $quantityUp.addEventListener("click", (event) => {
      event.preventDefault();
      const value = parseInt($quantityValue.dataset.value) + 1;
      $quantityValue.innerText = value;
      $quantityValue.dataset.value = value;
      updatePrices();
    });
  }

  if ($quantityDown && $quantityValue) {
    $quantityDown.addEventListener("click", (event) => {
      event.preventDefault();
      const value = Math.max(1, parseInt($quantityValue.dataset.value) - 1);
      $quantityValue.innerText = value;
      $quantityValue.dataset.value = value;
      updatePrices();
    });
  }

  $optionsSelects.forEach(($optionsSelect) => {
    $optionsSelect.addEventListener("change", () => {
      let foundVariant = findVariant(getOptionsString());

      if (foundVariant === null) {
        // Selected combination isn't a real variant — walk the other selects
        // to snap to the nearest available combination.
        for (let i = $optionsSelects.length - 1; i >= 0; i--) {
          if ($optionsSelects[i] === $optionsSelect) continue;
          for (const option of $optionsSelects[i].options) {
            $optionsSelects[i].value = option.value;
            foundVariant = findVariant(getOptionsString());
            if (foundVariant !== null) break;
          }
          if (foundVariant !== null) break;
        }
      }

      if (foundVariant !== null) $variantsSelect.value = foundVariant;
      syncOptionButtons();
      updatePrices();
    });
  });

  $optionContainers.forEach(($container) => {
    const $select = $container.querySelector(".option__select");
    $container
      .querySelectorAll(".option__buttons .option__button")
      .forEach(($button) => {
        $button.addEventListener("click", (event) => {
          event.preventDefault();
          $select.value = $button.dataset.optionValue;
          $select.dispatchEvent(new Event("change"));
        });
      });
  });

  $variantsSelect.addEventListener("change", () => {
    const variantOptions =
      $variantsSelect.options[$variantsSelect.selectedIndex].dataset
        .variantOptions;

    if (variantOptions) {
      JSON.parse(variantOptions).forEach((optionValue, index) => {
        if ($optionsSelects[index]) $optionsSelects[index].value = optionValue;
      });
      syncOptionButtons();
    }

    updatePrices();
  });

  $buttonCart?.addEventListener("click", async (event) => {
    event.preventDefault();

    const sellingPlanId = isSubscribeActive()
      ? $sellingPlansSelect.value
      : null;
    const cart = window.Carbon?.Cart;
    if (!cart) return;

    const response = await cart.addItemToCart(
      $variantsSelect.value,
      getQuantity(),
      sellingPlanId
    );

    if (response) openCartAside();
  });

  $buttonViewDetails?.addEventListener("click", (event) => {
    event.preventDefault();
    if ($infoElement.classList.contains("recomended__info")) {
      $infoElement.classList.add("recomended__info--details");
    } else {
      $infoElement.classList.add("product-info--details");
    }
  });

  // Sync the initial price to the active purchase type (e.g. subscription-only).
  updatePrices();
};

const renderMainRecommendation = (section, result) => {
  if (!result) return;

  const firstVariant = result.variants[0];

  const html = `
  <section class="quiz-results page-section">
    <div class="quiz-results__contents">
      <div
        class="contents__recomended contents__recomended--active"
        data-product-id="${result.productId.replace("shopify-", "")}"
        data-variant-ids="${result.variants
          ?.map((variant) => variant.variantRemoteId)
          .join(",")}"
      >
        <img
          class="recomended__image"
          src="${result.imageUrl}"
        >
        <div class="recomended__info ${
          result.sellingPlanGroups ? "recomended__info--subscribe" : ""
        }">
          <span class="info__recomend">We recommend...</span>
          <span class="info__title">${result.name}</span>
          <div class="info__reviews">
            <svg
              width="66"
              height="13"
              viewBox="0 0 66 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1.91667 10.5L5 0.5L8.08333 10.5L0 4.31579H10" fill="black"/>
              <path d="M15.9167 10.5L19 0.5L22.0833 10.5L14 4.31579H24" fill="black"/>
              <path d="M29.9167 10.5L33 0.5L36.0833 10.5L28 4.31579H38" fill="black"/>
              <path d="M43.9167 10.5L47 0.5L50.0833 10.5L42 4.31579H52" fill="black"/>
              <path d="M57.9167 10.5L61 0.5L64.0833 10.5L56 4.31579H66" fill="black"/>
            </svg>
            <span class="reviews__text">412 Reviews</span>
          </div>
          <span class="info__price">£${firstVariant.price}</span>

          <div class="info__description">
            ${result.productDescription ?? ""}
          </div>

          <div class="info__controls">
            <div class="controls__options">
            ${result.options
              .map(
                (option) => `
                <div class="option__div">
                  <span class="option__title">
                  ${
                    option.name == "Size" ? "Choose your bag size" : option.name
                  }
                  </span>
                  <div class="option__container  ${
                    option.name == "Size"
                      ? "option__container--buttons"
                      : option.name
                  }">
                  ${
                    option.name == "Size"
                      ? `
                      <div class="option__buttons">
                      ${option.values
                        ?.map(
                          (value, index) => `
                          <button
                            data-option-value="${handleize(value)}"
                            class="option__button ${
                              index == 0 ? "option__button--selected" : ""
                            }"
                          >
                            ${value}
                          </button>
                          `
                        )
                        .join("")}
                      </div>
                    `
                      : ""
                  }

                    <select
                      class="option__select"
                      data-option-handle="${handleize(option.name)}"
                    >
                     ${option.values
                       ?.map(
                         (value, index) => `
                        <option
                          value="${handleize(value)}"
                          ${index == 0 ? "selected" : ""}
                        >
                          ${value}
                        </option>
                      `
                       )
                       .join("")}
                    </select>
                    <svg
                      class="option__icon"
                      width="18"
                      height="10"
                      viewBox="0 0 18 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M18 1.48121L10.7847 8.75506C9.82606 9.72075 8.28942 9.74757 7.29914 8.83539L7.21563 8.7549L0 1.48123L0.973396 0.5L8.18902 7.77367C8.61752 8.20562 9.30054 8.2244 9.75141 7.83003L9.8114 7.77369L17.0266 0.500016L18 1.48121Z" fill="#1F1F1F"/>
                    </svg>
                  </div>
                </div>
              `
              )
              .join("")}
            </div>

            <div class="controls__variants">
              <select class="variants__select">
                ${result.variants
                  .map((variant) => {
                    const sellingPlanAllocations = JSON.stringify(
                      (variant.sellingPlans || []).map((plan) => ({
                        price: plan.price,
                        selling_plan_id: plan.remoteId,
                        selling_plan_name: plan.name,
                      }))
                    );
                    const variantOptions = JSON.stringify(
                      (variant.selectedOptions || []).map((o) =>
                        handleize(o.value)
                      )
                    );

                    return `
                      <option
                        data-variant-price="${variant.price}"
                        data-variant-handle="${handleize(variant.title)}"
                        data-variant-options="${escapeHtml(variantOptions)}"
                        data-selling-plan-allocations="${escapeHtml(
                          sellingPlanAllocations
                        )}"
                        value="${variant.variantRemoteId}"
                      >
                        ${variant.title}
                      </option>
                    `;
                  })
                  .join("")}
              </select>
              <svg class="variants__icon" width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 1.48121L10.7847 8.75506C9.82606 9.72075 8.28942 9.74757 7.29914 8.83539L7.21563 8.7549L0 1.48123L0.973396 0.5L8.18902 7.77367C8.61752 8.20562 9.30054 8.2244 9.75141 7.83003L9.8114 7.77369L17.0266 0.500016L18 1.48121Z" fill="#1F1F1F"/>
              </svg>
            </div>
            
            <div class="controls__purchase-types">
              ${
                !result.requiresSellingPlan
                  ? `
                <button
                  class="purchase-type purchase-type--one-time ${
                    !result.sellingPlanGroups?.length
                      ? "purchase-type--active"
                      : ""
                  }"
                >
                  <svg
                    class="purchase-type__icon"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle class="icon__outer" cx="10" cy="10" r="9.5" stroke="#202020"/>
                    <circle class="icon__inner" cx="10" cy="10" r="5.5" fill="currentColor" stroke="currentColor"/>
                  </svg>
                  <span class="purchase-type__text">One time purchase</span>
                </button>
              `
                  : ""
              }
              ${
                result.sellingPlanGroups?.length
                  ? `
                <button
                  class="purchase-type purchase-type--subscribe purchase-type--active"
                >
                  <svg
                    class="purchase-type__icon"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle class="icon__outer" cx="10" cy="10" r="9.5" stroke="#202020"/>
                    <circle class="icon__inner" cx="10" cy="10" r="5.5" fill="currentColor" stroke="currentColor"/>
                  </svg>

                  <span class="purchase-type__text">Subscribe</span>
                </button>
              `
                  : ""
              }
            </div>

            ${
              result.sellingPlanGroups?.length
                ? `
              <div class="controls__selling-plans">
                <ul class="selling-plans__list">
                  <li class="list__item">
                    <svg
                      class="list__icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2800_6958)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99951 0C3.57975 0 0 3.5797 0 7.99943C0 12.4194 3.58415 15.9989 7.99951 15.9989C12.4149 15.9989 15.999 12.4194 15.999 7.99943C15.999 3.5797 12.4193 0 7.99951 0ZM1.5 7.99943C1.5 4.40815 4.40817 1.5 7.99951 1.5C11.5908 1.5 14.499 4.40815 14.499 7.99943C14.499 11.5904 11.587 14.4989 7.99951 14.4989C4.412 14.4989 1.5 11.5904 1.5 7.99943ZM11.9788 4.59167L6.56039 10.01L4.32352 7.59674L3.22341 8.61643L5.98984 11.601L6.51939 12.1723L7.07022 11.6215L13.0394 5.65234L11.9788 4.59167Z" fill="#202020"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_2800_6958">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <span
                      class="list__text text-extra-small"
                    >
                      25% off your first three orders with <b class="text-extra-small">START25</b>
                    </span>
                  </li>
                  <li class="list__item">
                    <svg
                      class="list__icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2800_6958)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99951 0C3.57975 0 0 3.5797 0 7.99943C0 12.4194 3.58415 15.9989 7.99951 15.9989C12.4149 15.9989 15.999 12.4194 15.999 7.99943C15.999 3.5797 12.4193 0 7.99951 0ZM1.5 7.99943C1.5 4.40815 4.40817 1.5 7.99951 1.5C11.5908 1.5 14.499 4.40815 14.499 7.99943C14.499 11.5904 11.587 14.4989 7.99951 14.4989C4.412 14.4989 1.5 11.5904 1.5 7.99943ZM11.9788 4.59167L6.56039 10.01L4.32352 7.59674L3.22341 8.61643L5.98984 11.601L6.51939 12.1723L7.07022 11.6215L13.0394 5.65234L11.9788 4.59167Z" fill="#202020"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_2800_6958">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <span
                      class="list__text text-extra-small"
                      >Complementary welcome box with <b class="text-extra-small">FIRST</b> order
                    </span>
                  </li>
                  <li class="list__item">
                    <svg
                      class="list__icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2800_6958)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99951 0C3.57975 0 0 3.5797 0 7.99943C0 12.4194 3.58415 15.9989 7.99951 15.9989C12.4149 15.9989 15.999 12.4194 15.999 7.99943C15.999 3.5797 12.4193 0 7.99951 0ZM1.5 7.99943C1.5 4.40815 4.40817 1.5 7.99951 1.5C11.5908 1.5 14.499 4.40815 14.499 7.99943C14.499 11.5904 11.587 14.4989 7.99951 14.4989C4.412 14.4989 1.5 11.5904 1.5 7.99943ZM11.9788 4.59167L6.56039 10.01L4.32352 7.59674L3.22341 8.61643L5.98984 11.601L6.51939 12.1723L7.07022 11.6215L13.0394 5.65234L11.9788 4.59167Z" fill="#202020"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_2800_6958">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <span
                      class="list__text text-extra-small"
                      >Free tracked delivery
                    </span>
                  </li>
                  <li class="list__item">
                    <svg
                      class="list__icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2800_6958)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99951 0C3.57975 0 0 3.5797 0 7.99943C0 12.4194 3.58415 15.9989 7.99951 15.9989C12.4149 15.9989 15.999 12.4194 15.999 7.99943C15.999 3.5797 12.4193 0 7.99951 0ZM1.5 7.99943C1.5 4.40815 4.40817 1.5 7.99951 1.5C11.5908 1.5 14.499 4.40815 14.499 7.99943C14.499 11.5904 11.587 14.4989 7.99951 14.4989C4.412 14.4989 1.5 11.5904 1.5 7.99943ZM11.9788 4.59167L6.56039 10.01L4.32352 7.59674L3.22341 8.61643L5.98984 11.601L6.51939 12.1723L7.07022 11.6215L13.0394 5.65234L11.9788 4.59167Z" fill="#202020"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_2800_6958">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <span
                      class="list__text text-extra-small"
                      >Exclusive rewards and perks
                    </span>
                  </li>
                  <li class="list__item">
                    <svg
                      class="list__icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2800_6958)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99951 0C3.57975 0 0 3.5797 0 7.99943C0 12.4194 3.58415 15.9989 7.99951 15.9989C12.4149 15.9989 15.999 12.4194 15.999 7.99943C15.999 3.5797 12.4193 0 7.99951 0ZM1.5 7.99943C1.5 4.40815 4.40817 1.5 7.99951 1.5C11.5908 1.5 14.499 4.40815 14.499 7.99943C14.499 11.5904 11.587 14.4989 7.99951 14.4989C4.412 14.4989 1.5 11.5904 1.5 7.99943ZM11.9788 4.59167L6.56039 10.01L4.32352 7.59674L3.22341 8.61643L5.98984 11.601L6.51939 12.1723L7.07022 11.6215L13.0394 5.65234L11.9788 4.59167Z" fill="#202020"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_2800_6958">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <span
                      class="list__text text-extra-small"
                      >Simple subscription management
                    </span>
                  </li>
                </ul>
                <div class="selling-plans__container">
                  <select class="container__select">
                    ${result.sellingPlanGroups
                      .flatMap((group) => group.sellingPlans || [])
                      .map(
                        (plan, index) => `
                        <option
                          value="${plan.remoteId}"
                          ${index === 0 ? "selected" : ""}
                        >
                          ${plan.name}
                        </option>
                      `
                      )
                      .join("")}
                  </select>
                  <svg
                    class="container__icon"
                    width="18"
                    height="10"
                    viewBox="0 0 18 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M18 1.48121L10.7847 8.75506C9.82606 9.72075 8.28942 9.74757 7.29914 8.83539L7.21563 8.7549L0 1.48123L0.973396 0.5L8.18902 7.77367C8.61752 8.20562 9.30054 8.2244 9.75141 7.83003L9.8114 7.77369L17.0266 0.500016L18 1.48121Z" fill="#1F1F1F"/>
                  </svg>
                </div>
              </div>
            `
                : ""
            }

            <div class="controls__buttons">
              <div class="controls__quantity">
                <span class="quantity__title">Quantity</span>
                <div class="quantity__container">
                  <span
                    class="quantity__value"
                    data-value="1"
                    >1</span
                  >
                  <div class="quantity__buttons">
                    <button class="quantity__down">
                      <svg
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M13 0.763164L7.78892 6.4206C7.0966 7.17169 5.9868 7.19256 5.2716 6.48308L5.21129 6.42048L0 0.763176L0.703009 0L5.9143 5.6573C6.22377 5.99326 6.71706 6.00786 7.04268 5.70113L7.08601 5.65731L12.297 1.21337e-05L13 0.763164Z" fill="#1F1F1F"/>
                      </svg>
                    </button>
                    <svg
                      class="quantity__seperator"
                      width="2"
                      height="24"
                      viewBox="0 0 2 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M1 0V23.5" stroke="#D8D8D8"/>
                    </svg>

                    <button class="quantity__up">
                      <svg
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9.10064e-09 6.23684L5.21108 0.579402C5.9034 -0.171694 7.0132 -0.192558 7.7284 0.516922L7.78871 0.579524L13 6.23682L12.297 7L7.0857 1.3427C6.77623 1.00674 6.28294 0.992136 5.95732 1.29887L5.91399 1.34269L0.703031 6.99999L9.10064e-09 6.23684Z" fill="#1F1F1F"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <button class="button button--primary controls__button controls__button--cart">
                Add to Cart&nbsp-&nbsp
                <span class="button__price">
                  ${formatMoney(firstVariant.price, firstVariant.currencyCode)}
                </span>
              </button>
              <button class="button button--secondary button--outlined controls__button controls__button--details">
                View details
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  `;

  section.innerHTML = html;

  setUpFunctionality(section.querySelector(".recomended__info"));
};

const renderOtherRecommendations = (section, results) => {
  if (!results?.length) return;

  const html = `
    <section class="quiz-results page-section">
      <div class="quiz-results__contents">
        <div class="contents__other">
          <div class="other__products other__products--mobile">
            <div class="products__swiper swiper">
              <div class="swiper__wrapper swiper-wrapper">
                ${results
                  .map((product) => {
                    const firstVariant = product.variants?.[0];
                    const variantIds = product.variants
                      ?.map((variant) => variant.variantRemoteId)
                      .join(",");
                    const hasSellingPlanGroups =
                      !!product.sellingPlanGroups?.length;

                    return `
                      <div
                        class="other__product other__product--active wrapper__slide swiper-slide"
                        data-product-id="${product.productId.replace(
                          "shopify-",
                          ""
                        )}"
                        data-variant-ids="${variantIds}"
                      >
                        <img
                          class="product__image"
                          src="${product.imageUrl}"
                        >
                        <div class="product__info">
                          <span class="info__title">
                            ${product.name}
                          </span>

                          <div class="info__controls">
                            <div class="controls__variants">
                              <select class="variants__select">
                                ${product.variants
                                  .map((variant) => {
                                    const sellingPlanAllocations =
                                      JSON.stringify(
                                        (variant.sellingPlans || []).map(
                                          (plan) => ({
                                            price: plan.price,
                                            selling_plan_id: plan.remoteId,
                                            selling_plan_name: plan.name,
                                          })
                                        )
                                      );

                                    return `
                                      <option
                                        data-variant-price="${variant.price}"
                                        data-selling-plan-allocations="${escapeHtml(
                                          sellingPlanAllocations
                                        )}"
                                        value="${variant.variantRemoteId}"
                                      >
                                        ${variant.title}
                                      </option>
                                    `;
                                  })
                                  .join("")}
                              </select>
                              <svg
                                class="variants__icon"
                                width="18"
                                height="10"
                                viewBox="0 0 18 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M18 1.48121L10.7847 8.75506C9.82606 9.72075 8.28942 9.74757 7.29914 8.83539L7.21563 8.7549L0 1.48123L0.973396 0.5L8.18902 7.77367C8.61752 8.20562 9.30054 8.2244 9.75141 7.83003L9.8114 7.77369L17.0266 0.500016L18 1.48121Z" fill="#1F1F1F"/>
                              </svg>
                            </div>
                            <div class="controls__purchase-types ${
                              product.requiresSellingPlan ||
                              !hasSellingPlanGroups
                                ? "controls__purchase-types--hidden"
                                : ""
                            }">
                              ${
                                !product.requiresSellingPlan
                                  ? `
                                <button
                                  class="purchase-type purchase-type--one-time ${
                                    !hasSellingPlanGroups
                                      ? "purchase-type--active"
                                      : ""
                                  }"
                                >
                                  <svg
                                    class="purchase-type__icon"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle class="icon__outer" cx="10" cy="10" r="9.5" stroke="#202020"/>
                                    <circle class="icon__inner" cx="10" cy="10" r="5.5" fill="currentColor" stroke="currentColor"/>
                                  </svg>
                                  <span class="purchase-type__text">One time purchase</span>
                                </button>
                              `
                                  : ""
                              }
                              ${
                                hasSellingPlanGroups
                                  ? `
                                <button
                                  class="purchase-type purchase-type--subscribe purchase-type--active"
                                >
                                  <svg
                                    class="purchase-type__icon"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle class="icon__outer" cx="10" cy="10" r="9.5" stroke="#202020"/>
                                    <circle class="icon__inner" cx="10" cy="10" r="5.5" fill="currentColor" stroke="currentColor"/>
                                  </svg>

                                  <span class="purchase-type__text">Weekly subscription</span>
                                </button>
                              `
                                  : ""
                              }
                            </div>
                            ${
                              hasSellingPlanGroups
                                ? `
                              <div class="controls__selling-plans">
                                <div class="selling-plans__container">
                                  <select class="container__select">
                                    ${product.sellingPlanGroups
                                      .flatMap(
                                        (group) => group.sellingPlans || []
                                      )
                                      .map(
                                        (plan, index) => `
                                        <option
                                          value="${plan.remoteId}"
                                          ${index === 0 ? "selected" : ""}
                                        >
                                          ${plan.name}
                                        </option>
                                      `
                                      )
                                      .join("")}
                                  </select>
                                  <svg
                                    class="container__icon"
                                    width="18"
                                    height="10"
                                    viewBox="0 0 18 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M18 1.48121L10.7847 8.75506C9.82606 9.72075 8.28942 9.74757 7.29914 8.83539L7.21563 8.7549L0 1.48123L0.973396 0.5L8.18902 7.77367C8.61752 8.20562 9.30054 8.2244 9.75141 7.83003L9.8114 7.77369L17.0266 0.500016L18 1.48121Z" fill="#1F1F1F"/>
                                  </svg>
                                </div>
                              </div>
                            `
                                : ""
                            }
                            <div class="controls__buttons">
                              <button class="button button--primary controls__button controls__button--cart">
                                Add to Cart&nbsp-&nbsp
                                <span class="button__price">
                                  ${
                                    firstVariant
                                      ? formatMoney(
                                          firstVariant.price,
                                          firstVariant.currencyCode
                                        )
                                      : ""
                                  }
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    `;
                  })
                  .join("")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `;

  section.innerHTML = html;

  section.querySelectorAll(".other__product").forEach(($product) => {
    setUpFunctionality($product.querySelector(".product__info"));
  });

  const $swiper = section.querySelector(".products__swiper");
  if ($swiper) {
    new Swiper($swiper, {
      direction: "horizontal",
      speed: 1000,
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 12,
      centeredSlides: false,
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  }
};

export default QuizMain;
